document.addEventListener("DOMContentLoaded", () => {
  $("a[data-method]").on("click", function(e) {
    e.preventDefault();

    let token = $('meta[name="csrf-token"]').attr("content");
    let action = $(this).attr("href");
    let method = $(this).data("method");
    let message = $(this).data("confirm");

    if (!message || confirm(message)) {
      let html = `<form action="${action}" method="POST" style="display:none;">
                    <input type="hidden" name="_token" value="${token}"/>
                    <input type="hidden" name="_method" value="${method}"/>
                  </form>`;

      $(html)
        .appendTo("body")
        .submit();
    }
  });

  $(".accordion-active").collapse({
    accordion: true,
    open: function() {
      this.slideDown(550);
    },
    close: function() {
      this.slideUp(550);
    }
  });

  var hash = window.location.hash.substr(1);
  var arr = hash;
  if (arr[0] && arr[1]) {
    $("#tab-" + arr[0] + " a").click();
    $("#" + hash + " a").click();
  }
});
